import type { SceneInspirationModal } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

// ---------------------------------------------------------------------------
// Business logic constants (not CMS content — stay in code)
// ---------------------------------------------------------------------------

/** Minimum favorites required before "See Sessions" is enabled. */
export const MINIMUM_FAVORITES = 2

/** Whether the skip button should be shown (A/B test config). */
export const SHOW_SKIP_BUTTON = true

// ---------------------------------------------------------------------------
// CMS fallback — SceneInspirationModal (Pattern B, MaxDepth=3)
// Category identifiers and sceneIds are kept: stores/main.ts builds
// sceneToBucket from this data at module init before CMS resolves.
// ---------------------------------------------------------------------------

const nullImage = { assetId: '', alt: '', url: '' }

export const sceneInspirationModalFallback = {
  internalName: 'Scene Inspiration Modal',
  title: '',
  subtitle: '',
  seeSessionsButtonText: '',
  skipButtonText: '',
  categories: [
    {
      internalName: 'Category: EU Outdoor Destinations',
      identifier: 'elite-unlimited-outdoor',
      title: '',
      description: '',
      cardStyle: 'dark',
      sortOrder: 0,
      scenes: [
        {
          internalName: 'Scene: Beach Destination',
          sceneId: 'co-1',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 0
        },
        {
          internalName: 'Scene: Lake Destination',
          sceneId: 'co-2',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 1
        },
        {
          internalName: 'Scene: Choose Your Destination 1',
          sceneId: 'co-3',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 2
        },
        {
          internalName: 'Scene: Waterfall Destination',
          sceneId: 'co-4',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 3
        },
        {
          internalName: 'Scene: Choose Your Destination 2',
          sceneId: 'co-5',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 4
        },
        {
          internalName: 'Scene: Choose Your Destination 3',
          sceneId: 'co-6',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 5
        },
        {
          internalName: 'Scene: Choose Your Destination 4',
          sceneId: 'co-7',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 6
        },
        {
          internalName: 'Scene: Choose Your Destination 5',
          sceneId: 'co-8',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 7
        },
        {
          internalName: 'Scene: Choose Your Destination 6',
          sceneId: 'co-9',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 8
        }
      ]
    },
    {
      internalName: 'Category: Outdoor Destinations',
      identifier: 'outdoor-destinations',
      title: '',
      description: '',
      cardStyle: 'light',
      sortOrder: 1,
      scenes: [
        {
          internalName: 'Scene: City Location 1',
          sceneId: 'sd-1',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 0
        },
        {
          internalName: 'Scene: City Location 2',
          sceneId: 'sd-2',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 1
        },
        {
          internalName: 'Scene: City Location 3',
          sceneId: 'sd-3',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 2
        },
        {
          internalName: 'Scene: City Location 4',
          sceneId: 'sd-4',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 3
        },
        {
          internalName: 'Scene: Rustic Location 1',
          sceneId: 'sd-5',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 4
        },
        {
          internalName: 'Scene: City Location 5',
          sceneId: 'sd-6',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 5
        },
        {
          internalName: 'Scene: Rustic Location 2',
          sceneId: 'sd-7',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 6
        },
        {
          internalName: 'Scene: City Location 6',
          sceneId: 'sd-8',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 7
        },
        {
          internalName: 'Scene: Outdoor Location',
          sceneId: 'sd-9',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 8
        }
      ]
    },
    {
      internalName: 'Category: Studio and School',
      identifier: 'studio-and-school',
      title: '',
      description: '',
      cardStyle: 'light',
      sortOrder: 2,
      scenes: [
        {
          internalName: 'Scene: Yearbook',
          sceneId: 'st-1',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 0
        },
        {
          internalName: 'Scene: Exposure',
          sceneId: 'st-2',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 1
        },
        {
          internalName: 'Scene: Emerge',
          sceneId: 'st-3',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 2
        },
        {
          internalName: 'Scene: Living Walls',
          sceneId: 'st-4',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 3
        },
        {
          internalName: 'Scene: Shadowland',
          sceneId: 'st-5',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 4
        },
        {
          internalName: 'Scene: Prime Time',
          sceneId: 'st-6',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 5
        },
        {
          internalName: 'Scene: Timeless',
          sceneId: 'st-7',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 6
        },
        {
          internalName: 'Scene: Center Stage',
          sceneId: 'st-8',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 7
        },
        {
          internalName: 'Scene: Wonderlight',
          sceneId: 'st-9',
          name: '',
          image: nullImage,
          sessionLabel: '',
          sortOrder: 8
        }
      ]
    }
  ]
} as unknown as SceneInspirationModal
